<template>
  <div class="month-container">
    <img
      @click="monthMinus"
      src="../../icons/dod/month_switcher_arrow-left.svg"
      alt=""
    />
    <div class="month-name p-0">
      <div class="p-0 mr-2">{{ month }}</div>
      <div class="p-0 m-0">{{ year }}</div>
    </div>
    <img
      @click="monthPlus"
      src="../../icons/dod/month_switcher_arrow-right.svg"
      alt=""
    />
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "DodMonthSwitcher",
  props: ["date"],
  emits: ["onMonthChange"],
  data() {
    return {
      month: "",
      year: "",
      selectedDate: "",
    };
  },
  mounted() {
    if (this.date) {
      this.selectedDate = this.date;
    } else {
      this.selectedDate = moment().toDate();
    }
    moment.locale("pl");
    this.month = this.capitalizeFirstLetter(
      moment(this.selectedDate).format("MMMM")
    );
    this.year = moment(this.selectedDate).get("year");
  },

  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    emitMonthChange() {
      this.$emit("onMonthChange", this.selectedDate);
    },
    monthMinus() {
      const newDate = moment(this.selectedDate).add(-1, "month");
      this.selectedDate = newDate.toDate();
      this.month = this.capitalizeFirstLetter(
        moment(this.selectedDate).format("MMMM")
      );
      this.year = moment(this.selectedDate).get("year");
      this.emitMonthChange();
    },

    monthPlus() {
      const newDate = moment(this.selectedDate).add(1, "month");
      this.selectedDate = newDate.toDate();
      this.month = this.capitalizeFirstLetter(
        moment(this.selectedDate).format("MMMM")
      );
      this.year = moment(this.selectedDate).get("year");
      this.emitMonthChange();
    },
  },
};
</script>

<style scoped>
.month-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  padding: 0;
  margin: 0;
  font-size: 20px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
}
img {
  width: 44px;
  cursor: pointer;
  border-radius: 4px;
}
img:hover {
  background: rgb(226, 226, 226);
}
.month-name {
  display: flex;
  width: 130px;
  justify-content: center;
  align-content: center;
}
</style>